import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import PageLoader from "../common_component/PageLoader.js";

function ForgotPassword(props) {
	const [password, setPassword] = useState("")
	const [repeatPassword, setRepeatPassword] = useState("")
	const [passwordRating, setPasswordRating] = useState(0)
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const [loading, setLoading] = useState(true);
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

	async function checkForgotPasswordIdStatus() {
		var object = {};
		object.id = props.match.params.id;

		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/check-forgot-password-id-status`, { method: 'POST', body: JSON.stringify(object), headers: { "Content-type": "application/json; charset=UTF-8" } }
		);
		const body = await response.json();
		if (body.operation === "danger") {
			swal({
				title: "Warning!",
				text: body.message,
				icon: "warning",
				buttons: {
					login: {
						text: "Login",
						value: "login",
					},
					forgot: {
						text: "Forgot Password",
						value: "forgot",
					}
				},
				dangerMode: true,  // optional for styling
			})
				.then((value) => {
					if (value === "login") {
						window.location = `/login`;
					} else {
						// default to login on "login" button or any other case (including click outside)
						window.location = `/forgot-password-email`;
					}
				});
		}
		setLoading(false);
	}

	useEffect(() => {
		checkForgotPasswordIdStatus();
	}, [])

	const passwordChecker = (password) => {

		let a = 0
		if (password.length >= 8) {
			a += 25
		}
		if (/[a-z][A-Z]/.test(password)) {
			a += 25
		}
		if (/[0-9]/.test(password)) {
			a += 25;
		}
		if (/[^a-zA-Z0-9]/.test(password)) {
			a += 25;
		}
		console.log(a);
		return a;
	}

	const forgotPassword = (e) => {

		e.preventDefault();
		var object = {};
		object.password = password;
		object.cpassword = repeatPassword;
		object.changePasswordId = props.match.params.id;

		if (password === "") {
			swal("Warning!", "Password cannot be empty", "warning");
			return false;
		}

		// if (password.length < 8) {
		// 	swal("Warning!", "Password must have atleast 8 characters.", "warning");
		// 	return false;
		// }

		if (repeatPassword === "") {
			swal("Warning!", "Please confirm your password by re-typing.", "warning");
			return false;
		}

		if (repeatPassword !== password) {
			swal("Warning!", "Confirm and match both the passwords.", "warning");
			setRepeatPassword("")
			return false;
		}

		setMainSubmitButtonState(true);

		axios.post(`${process.env.REACT_APP_SERVER_URL}/forgot-password-email`, object).then((res) => {
			setMainSubmitButtonState(false);
			if (res.data.operation == "success") {
				swal("Great!", res.data.message, "success", {
					buttons: {
						continue: {
							text: "OK",
							value: "continue",
						},
					}
				}).then((result) => {
					//console.log(result);
					switch (result) {
						case "continue":
							window.location = `/login`;
							break;
						default:
							window.location = `/login`;
							break;

					}
				});
			}
			else {
				swal({
					title: "Warning!",
					text: "Unable to update password. Please request a new reset link.",
					icon: "warning",
					buttons: {
						login: {
							text: "Login",
							value: "login",
						},
						forgot: {
							text: "New Link",
							value: "forgot",
						}
					},
					dangerMode: true,  // optional for styling
				})
					.then((value) => {
						if (value === "login") {
							window.location = `/login`;
						} else {
							// default to login on "login" button or any other case (including click outside)
							window.location = `/forgot-password-email`;
						}
					});
			}
		})
	}

	return (
		<>
			<div className="app-blank bgi-size-cover bgi-attachment-fixed bgi-position-center bg-forgot-password bgi-no-repeat">
				<div className="d-flex flex-column flex-root min-vh-100">
					<div className="d-flex flex-column flex-lg-row flex-grow-1">

						{/* Left side (Logo + Description) */}
						<div className="d-none d-lg-flex flex-center w-lg-50 p-5">
							<div className="d-flex flex-column align-items-center">
								<img alt="Logo" src={`${process.env.REACT_APP_LOGO}`} className="mb-4" style={{ maxWidth: '200px' }} />
								<h2 className="text-white text-center fw-normal m-0 fs-3">Ultimate Business Management Solution!</h2>
							</div>
						</div>

						{/* Right side (Form) */}
						<div className="flex-grow-1 d-flex justify-content-center align-items-center p-4 p-lg-10">
							<div className="bg-body rounded-4 w-100 w-md-600px p-6 p-md-10">
								{loading ?
									<PageLoader />
									:
									<form className="form w-100">
										<div className="text-center mb-6">
											<h1 className="text-gray-900 fw-bolder mb-2 fs-3 fs-md-1">Setup New Password</h1>
											<div className="text-gray-500 fw-semibold fs-7 fs-md-6">
												Have you already reset the password?
												<a href="/login" className="link-primary fw-bold ms-1">Sign in</a>
											</div>
										</div>

										{/* Password input */}
										<div className="fv-row mb-6">
											<div className="position-relative mb-2">
												<input
													className="form-control bg-transparent"
													type={isPasswordVisible ? "text" : "password"}
													placeholder="Password"
													value={password}
													onChange={(e) => {
														setPassword(e.target.value);
														setPasswordRating(passwordChecker(e.target.value));
													}}
												/>
												<span
													className="btn btn-sm btn-icon position-absolute top-50 end-0 translate-middle-y me-2"
													onClick={() => setIsPasswordVisible(!isPasswordVisible)}
												>
													<i className={`bi ${isPasswordVisible ? "bi-eye" : "bi-eye-slash"} fs-5`}></i>
												</span>
											</div>
											<div className="d-flex align-items-center">
												{[0, 1, 2, 3].map((i) => (
													<div
														key={i}
														className="flex-grow-1 rounded h-3px me-1"
													//style={{ backgroundColor: getBarColor(passwordRating, i) }}
													></div>
												))}
											</div>
											{/* {passwordRating < 100 && (
												<div className="text-muted small">Use 8+ characters with letters, numbers & symbols.</div>
											)} */}
										</div>

										{/* Confirm Password */}
										<div className="fv-row mb-6">
											<input
												className="form-control bg-transparent mb-2"
												placeholder="Confirm Password"
												value={repeatPassword}
												onChange={(e) => setRepeatPassword(e.target.value)}
											/>
											{repeatPassword && password && (
												<div className={repeatPassword === password ? "text-success" : "text-danger"}>
													{repeatPassword === password ? "Password Match." : "Password Mismatch."}
												</div>
											)}
										</div>

										{/* Submit */}
										<div className="d-grid">
											<button data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
												disabled={mainSubmitButtonState} type="button" onClick={forgotPassword} className="btn btn-primary">
												Submit
											</button>
										</div>
									</form>}

								<div className="d-flex justify-content-center gap-3 mt-4 small">
									<a href="https://www.spoterp.com/terms.html" target="_blank">Terms</a>
									<a href="https://www.spoterp.com/faq.html" target="_blank">FAQs</a>
									<a href="https://www.spoterp.com/erp-software-features.html" target="_blank">Features</a>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

		</>
	);
}
export default ForgotPassword;